import { Outlet } from 'react-router-dom';
import { HeaderAdelante } from './HeaderAdelante';

/**
 * Layout del área Admin — desktop-first.
 *
 * Pensado para personal de oficina con PC y pantalla grande:
 *   - Header oscuro full-width arriba con nav horizontal
 *   - Container centrado max-w-7xl para que las tablas/CRUDs no se estiren
 *   - Padding generoso
 *
 * Se monta como `element` de la ruta `/admin` en `router/routes.tsx`,
 * y las pantallas hijas se renderizan dentro de `<Outlet />`.
 */
export function LayoutAdmin() {
  return (
    <div className="min-h-screen bg-zinc-50 text-foreground">
      <HeaderAdelante variant="admin" />
      <main className="container mx-auto max-w-7xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
